import styled, { css } from 'styled-components';
import { rem } from 'polished';

interface IStyledNewsletter {
  topRadiusFlat: any;
  hor?: boolean;
  forceVert?: boolean;
}

export const StyledNewsletter = styled.div<IStyledNewsletter>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.blue_1_65};
  border-radius: ${({ topRadiusFlat }) =>
    topRadiusFlat ? `0 0 8px 8px` : `8px`};
  padding: ${rem(`16px`)};
  margin-bottom: ${rem(`16px`)};
  ${({ theme, forceVert }) =>
    !forceVert &&
    theme.breakpoints.tablet`
    padding: ${rem(`16px`)};
  `}
  ${({ theme, forceVert }) =>
    !forceVert &&
    theme.breakpoints.desktop`
    padding: ${rem(`36px`)};
    justify-content: center;
    align-items: center;
  `}
  .newsletter__header {
    display: flex;
    margin-bottom: ${rem(`8px`)};
    pointer-events: none;
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      justify-content: center;
      margin-bottom: ${rem(`24px`)};
    `}
  }
  .newsletter__content {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex: 1 0;
    min-width: 0;
    pointer-events: none;
    ${({ theme }) => theme.breakpoints.phone`
      flex-direction: ${({ hor }) => (hor ? `row` : `column`)};
    `}
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      max-width: ${rem(`640px`)};
      justify-content: center;
      align-items: center;
    `}
  }
  .newsletter__form {
    flex: 1 0 auto;
    ${({ hor }) =>
      hor
        ? css`
            ${({ theme }) => theme.breakpoints.phone`
              padding-left: ${rem(32)};
              max-width: ${rem(450)};
            `}
          `
        : null}
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      display: grid;
      grid-template-columns: repeat(3, auto);
      grid-template-rows: 1fr;
      gap: ${rem(`6px`)};
      align-items: center;
    `}
  }
  .newsletter__text {
    margin-bottom: ${rem(`16px`)};
    flex: 1 0;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    ${({ theme }) => theme.breakpoints.wide`
      -webkit-line-clamp: 8;
    `}
    pointer-events: none;
    color: ${({ theme }) => theme.colors.white_1_90};
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.phone`
      min-width: ${rem(`270px`)};
    `}
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.tablet`
      min-width: ${rem(`250px`)};
    `}
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      margin-bottom: ${rem(`24px`)};
      text-align: center;
    `}
  }
  .newsletter__input-user {
    margin-bottom: ${rem(`8px`)};
    pointer-events: all;
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      margin-bottom: 0;
    `}
  }
  .newsletter__input-email {
    margin-bottom: ${rem(`16px`)};
    pointer-events: all;
    ${({ theme, forceVert }) =>
      !forceVert &&
      theme.breakpoints.desktop`
      margin-bottom: 0;
    `}
  }
  .newsletter__button {
    pointer-events: all;
    display: flex;
    align-items: center;
    justify-content: center;
    .svg {
      font-size: ${rem(`19px`)};
    }
  }
  .gatsby-image-wrapper {
    margin-top: ${rem(`72px`)};
    img {
      object-fit: contain;
    }
  }
`;
